import { useSelector } from "react-redux";
import { PhotoUploadErrors } from "../../../../photoUploadErrors";
import { selectImageUploadData } from "../../../../store/selectors";

export const usePhotoUploadError = () => {
  const { uploadValidationError } = useSelector(selectImageUploadData);

  const fileTooBig = {
    heading: "This photo’s file size is too large",
    subheading: "Our max photo file size is 20MB.",
    advice: "Please reduce the image size and try again.",
    imageClass: "validation-error",
    errorType: PhotoUploadErrors.TOO_BIG
  };
  const wrongFileType = {
    heading: "Sorry, this image format isn’t supported.",
    subheading: "Try selecting a JPEG or PNG.",
    advice: "Then upload the photo again.",
    imageClass: "validation-error",
    errorType: PhotoUploadErrors.WRONG_FILE_TYPE
  };
  const offline = {
    heading: "Your device is not connected to the internet.",
    subheading: null,
    advice: "Check your Wi-Fi or mobile signal & try again.",
    imageClass: "offline",
    errorType: PhotoUploadErrors.OFFLINE
  };
  const defaultError = {
    heading: "Sorry, something isn’t working.",
    subheading: "We’re looking into it.",
    advice: "Please check back later or try again.",
    imageClass: "validation-error",
    errorType: PhotoUploadErrors.DEFAULT_ERROR
  };

  let errorContent;

  switch (uploadValidationError) {
    case PhotoUploadErrors.TOO_BIG:
      errorContent = fileTooBig;
      break;
    case PhotoUploadErrors.WRONG_FILE_TYPE:
      errorContent = wrongFileType;
      break;
    case PhotoUploadErrors.OFFLINE:
      errorContent = offline;
      break;
    default:
      errorContent = defaultError;
  }

  return { errorContent };
};
